/**
 * Created by hj on 2017/8/24.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import { Form, Input, Button, Row, Col, DatePicker, Select, Tree, Table, TreeSelect } from 'antd';
import moment from 'moment';
import { DmsTab, SelectRange } from 'Components';
import { openNotice } from 'Utils';
import ProductModal from '../inventory/productModal';
const FormItem = Form.Item;
import { getProductCategory, getDictionay } from '../../service/product';
import { savePromotion, getPromotionDetail } from '../../service/promotion';
import './promotion.css';

class promotionAdd extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      opts: ['新建促销'],
      btnLoad: false,
      detail: {
        productId: '',
        price: ''
      },
      endOpen: false, // 控制失效时间选择
      categoryData: [],
      checkCategoryData: {
        'index': 0,
        'ids': [],
        'data': []
      },
      selectProductIndex: 0,
      productViewProps: {
        rowKey: 'idIndex',
        columns: [
          {
            title: '产品名称',
            dataIndex: 'product',
            render: (text, record, index) => {
              if (text || record.productCategoryIds) {
                return <span>{text}</span>
              } else {
                return <span onClick={this.openModal.bind(this, index)} className="href_select"><span>选择产品</span></span>
              }
            }
          }, {
            title: '产品分类',
            dataIndex: 'productCategoryIds',
            render: (text, record, index) => {
              if (record.productId) {
                return <span>{record.productCategory}</span>
              } else {
                /*
                return <span onClick={this.selectCategoryFn.bind(this, index)} className="href_select"><span>选择分类</span></span>
                */
                /*
                return <div id={'categoryIdAdd' + index}>
                  <Cascader expandTrigger="hover" disabled={(record.productCategoryIds && record.id) ? true : false}
                            changeOnSelect={true} options={this.state.categoryData}
                            onChange={this.updateProductFn.bind(this, 'productCategoryIds', index)} value={text}
                            placeholder="请选择产品类别"
                            getPopupContainer={() => document.getElementById('categoryIdAdd' + index)}/>
                </div>
                */
                return <div id={'categoryIdAdd' + index}>
                  <TreeSelect
                    /* showSearch */
                    style={{ width: 240 }}
                    value={text}
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="选择产品分类"
                    allowClear
                    treeDefaultExpandAll
                    onChange={this.updateProductFn.bind(this, 'productCategoryIds', index)}
                    /* getPopupContainer={() => document.getElementById('categoryIdAdd' + index)} */
                  >
                    {
                      this.renderCategoryTree(this.state.categoryData)
                    }
                  </TreeSelect>
                </div>
              }
            }
          }, {
            title: '规格',
            dataIndex: 'productSpec'
          }, {
            title: '单位',
            dataIndex: 'unit'
          }, {
            title: '产品标价(元)',
            dataIndex: 'price'
          }, {
            title: '折扣(%)',
            dataIndex: 'discount',
            render: (text, record, index) => {
              return <Input placeholder=">0 <100" value={text}
                            onChange={this.updateProductFn.bind(this, 'discount', index)} type="number"/>
            }
          }, {
            title: '折扣后价格(元)',
            dataIndex: 'newPrice',
            render: (text, record, index) => {
              if (!record.classifyId && record.productId) {
                return <Input value={text} placeholder=">0 <标价"
                              onChange={this.updateProductFn.bind(this, 'newPrice', index)} type="number"/>
              } else {
                return '';
              }
            }
          }, {
            title: '总量限制',
            dataIndex: 'quantityLimit',
            render: (text, record, index) => {
              return <Input value={text} placeholder="为0时不限制"
                            onChange={this.updateProductFn.bind(this, 'quantityLimit', index)} type="number"/>
            }
          }, {
            title: '每人限制',
            dataIndex: 'personalLimit',
            render: (text, record, index) => {
              return <Input value={text} placeholder="为0时不限制"
                            onChange={this.updateProductFn.bind(this, 'personalLimit', index)} type="number"/>
            }
          }, {
            title: '操作',
            dataIndex: 'idIndex',
            render: (text, record, index) => {
              return <a onClick={this.deleteLine.bind(this, index)}>删除</a>
            }
          }
        ],
        dataSource: []
      },
      promotionActivityType: [],
      selectedKeys: [], // 选中销售区域ID
      selectedNodes: [] // 选中销售区域
    }
  }

  //发布范围相关
  handleOk = (keys, nodes) => {
    const saleArea = nodes.map(x => x.name).join(',');
    this.setState({
      visible: false,
      selectedKeys: keys,
      selectedNodes: nodes
    });
    this.props.form.setFieldsValue({
      'saleArea': saleArea
    });
  }
  selectRegionFn () {
    this.selectRangModal.showModal();
  }

  initData (cb) {
    let self = this;
    getProductCategory().then(function (categoryResult) {
      /* 产品分类 */
      if (!categoryResult || categoryResult.code != 200) {
        openNotice('error', '产品分类数据获取失败，请重试', '');
        return;
      }
      self.setState({
        categoryData: categoryResult.data || []
      });
      if (typeof cb == 'function') {
        cb();
      }
    });
    getDictionay('promotion_category').then((result) => {
      // 促销活动 数据字典
      if (!result || result.code != 200) {
        openNotice('error', '促销活动数据字典获取失败，请重试', '');
        return;
      }
      self.setState({
        promotionActivityType: result.data || []
      });
    });
  }

  componentDidMount () {
    var promotionId = this.props.params.promotionId;
    let self = this;
    self.initData();
    if (promotionId != 0) {
      getPromotionDetail(promotionId).then((result) => {
        if (result && result.code == 200) {
          result = result.data;
          result.startTime = moment(result.startTime, 'YYYY-MM-DD HH:mm:ss');
          result.endTime = moment(result.endTime, 'YYYY-MM-DD HH:mm:ss');
          result.active = result.active + '';
          result.saleArea = (result.scopeList || []).map(x => (x.scopeName))
          let dataSource = [];
          (result.productList || []).map((item, index) => {
            dataSource.push({
              'id': item.id,
              'idIndex': index + 1,
              'product': item.productName,
              'productId': item.productId,
              'productCategory': item.productCategoryName,
              'productCategoryIds': item.productId ? item.productCategoryId : [item.productCategoryId + ''],
              'productSpec': item.productSpecName,
              'productSpecId': item.productSpecId,
              'unit': item.unitText,
              'price': item.showPrice,
              'discount': item.discount,
              'newPrice': item.discountedPrice || '',
              'quantityLimit': item.quantityLimit,
              'personalLimit': item.personalLimit
            });
            return '';
          });
          self.setState({
            'opts': ['新增促销'],
            'detail': result,
            'productViewProps': {
              ...this.state.productViewProps,
              dataSource: dataSource
            },
            'selectedKeys': (result.scopeList || []).map(x => (x.scopeId + '')), /* 确认保存后 销售区域存放 */
            'selectedNodes': (result.scopeList || []).map(x => {
              return { 'key': x.scopeId, 'name': x.scopeName }
            })
          });
        }
      });
    } else {
      self.setState({
        opts: ['新增促销'],
        detail: {
          ...this.state.detail
        },
        productViewProps: {
          ...this.state.productViewProps,
          dataSource: []
        }
      });
    }
  }

  openModal (index) {
    this.productModal.showModal();
    this.setState({
      'selectProductIndex': index
    });
  }

  selectProductBack (list) {//从弹框中接收数据
    if (!list || list.length == 0) {
      return;
    }
    const { productViewProps } = this.state;
    let self = this;
    let products = productViewProps.dataSource;
    list.forEach((item, index) => {
      if (products.findIndex(x => x.productSpecId === item.specId) === -1) {
        if (typeof item.specId == 'string') {
          item.specId = '';
        }
        if (index == 0) {
          products[self.state.selectProductIndex] = {
            'idIndex': '',
            'product': item.name,
            'productId': item.id,
            'productCategory': item.categoryText,
            'productCategoryIds': item.categoryId,
            'productSpec': item.specUnionKey,
            'productSpecId': item.specId,
            'unit': item.unitText,
            'price': item.originalPrice,
            'discount': '',
            'newPrice': '',
            'quantityLimit': 0,
            'personalLimit': 0
          };
        } else {
          products.push({
            'idIndex': '',
            'product': item.name,
            'productId': item.id,
            'productCategory': item.categoryText,
            'productCategoryIds': item.categoryId,
            'productSpec': item.specUnionKey,
            'productSpecId': item.specId,
            'unit': item.unitText,
            'price': item.originalPrice,
            'discount': '',
            'newPrice': '',
            'quantityLimit': 0,
            'personalLimit': 0
          });
        }
      }
    });
    products.map((qst, index) => {
      qst.idIndex = index + 1;
      return '';
    });
    this.setState({
      'productViewProps': {
        ...this.state.productViewProps,
        'dataSource': products
      }
    });
  }

  cancelHandle () {
    hashHistory.goBack()
  }

  submitHandle () {
    let self = this;
    self.setState({
      'btnLoad': true
    });

    const { validateFields, getFieldsValue } = this.props.form;
    validateFields((errors) => {//表单校验
      if (errors) {
        self.setState({
          'btnLoad': false
        });
        return
      }//表单校验有误，则不执行下面的代码
      const data = {
        ...getFieldsValue() //获取用户输入
      };
      // 生效期间 时间 格式化
      data.startTime = moment(data.startTime).format('YYYY-MM-DD HH:mm:ss');
      data.endTime = moment(data.endTime).format('YYYY-MM-DD HH:mm:ss');
      data.scopeIdList = (this.state.selectedKeys || []).map(x => parseInt(x, 10));
      data.productList = this.state.productViewProps.dataSource || [];
      data.id = this.state.detail.id || '';
      let flag = false;
      data.productList.map((item, index) => {
        if (!(item.productCategoryIds || item.productId)) {
          openNotice('warning', '请选择产品或者产品类别!', '');
          flag = true;
        } else {
          if (!item.discount) {
            openNotice('warning', '请输入折扣!', '');
            flag = true;
          }
        }
        if (typeof item.productCategoryIds == 'object') {
          item.productCategoryId = item.productCategoryIds[0];
        } else {
          item.productCategoryId = item.productCategoryIds;
        }
        return '';
      });
      if (flag) {
        self.setState({
          'btnLoad': false
        });
        return;
      }
      savePromotion(data).then((result) => {
        self.setState({
          'btnLoad': false
        });
        if (result && result.code == 200) {
          self.cancelHandle();
          openNotice('success', '保存成功', '');
        } else {
          openNotice('error', '促销新建失败', (result && result.message) ? result.message : '');
        }
      });
    });
  }

  addLine () {
    const { productViewProps } = this.state;
    let dataSource = productViewProps.dataSource || [];
    dataSource.push({
      'idIndex': '',
      'product': '',
      'productId': '',
      'productCategory': '',
      'productCategoryId': '',
      'productSpec': '',
      'productSpecId': '',
      'unit': '',
      'price': '',
      'discount': '',
      'newPrice': '',
      'quantityLimit': 0,
      'personalLimit': 0
    });
    dataSource.map((qst, index) => {
      qst.idIndex = index + 1;
      return '';
    });
    this.setState({
      productViewProps: {
        ...this.state.productViewProps,
        dataSource: dataSource
      }
    });
  }

  deleteLine (index) {
    const { productViewProps } = this.state;
    let dataSource = productViewProps.dataSource || [];
    dataSource.splice(index, 1);
    dataSource.map((qst, index) => {
      qst.idIndex = index + 1;
      return '';
    });
    this.setState({
      productViewProps: {
        ...this.state.productViewProps,
        dataSource: dataSource
      }
    });
  }

  updateProductFn (field, index, value) {
    // 价格行 form 修改
    let val = value;
    if (value.target) {
      val = value.target.value || '';
    }
    const { productViewProps } = this.state;
    let dataSource = productViewProps.dataSource;
    if (field == 'discount') {
      // 折扣
      if (val > 0 && val < 100) {
        dataSource[index].newPrice = (dataSource[index].price * val / 100).toFixed(2);
      } else {
        return;
      }
    }
    if (field == 'newPrice') {
      // 折扣后价格
      if (val > 0 && val < dataSource[index].price) {
        dataSource[index].discount = (val / dataSource[index].price * 100).toFixed(2);
      }
    }
    if (field == 'quantityLimit' || field == 'personalLimit') {
      // 总量限制 每人限量
      if (val < 0) {
        val = 0;
      }
    }
    dataSource[index][field] = val;
    this.setState({
      productViewProps: {
        ...this.state.productViewProps,
        dataSource: dataSource
      }
    });
  }

  disabledStartDate = (startValue) => {
    // 限制生效时间的选择范围
    const { getFieldsValue } = this.props.form;
    const endValue = getFieldsValue(['endTime']).endTime;
    if (!startValue || !endValue) {
      return false;
    }
    return startValue.valueOf() > endValue.valueOf();
  }
  disabledEndDate = (endValue) => {
    // 限制失效时间的选择范围
    const { getFieldsValue } = this.props.form;
    const startValue = getFieldsValue(['startTime']).startTime;
    if (!endValue || !startValue) {
      return false;
    }
    return endValue.valueOf() <= startValue.valueOf();
  }
  handleStartOpenChange = (open) => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  }
  handleEndOpenChange = (open) => {
    this.setState({ endOpen: open });
  }

  renderCategoryTree = (data) => data.map((item, key) => {
    if (item.children && item.children.length) {
      return <TreeSelect.TreeNode key={`${item.key}`} title={item.label} value={item.value}>{this.renderCategoryTree(item.children)}</TreeSelect.TreeNode>;
    }
    return <TreeSelect.TreeNode key={`${item.key}`} title={item.label} value={item.value} />;
  });

  render () {
    const { opts, detail, selectedKeys, selectedNodes, productViewProps, promotionActivityType, btnLoad, endOpen } = this.state;
    const { getFieldDecorator } = this.props.form;
    let self = this;
    /* 生成区域树 */
    const loop = data => data.map((item, key) => {
      if (item.children && item.children.length) {
        return <Tree.TreeNode key={`${item.key}`} title={item.label}>{loop(item.children)}</Tree.TreeNode>;
      }
      return <Tree.TreeNode key={`${item.key}`} title={item.label} />;
    });
    return <div>
      <DmsTab options={opts} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' loading={btnLoad} onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="编码：" hasFeedback>
                {getFieldDecorator('code', {
                  initialValue: (detail !== null && detail.code) ? detail.code : ''
                })(<Input placeholder="编码自动生成" type="text" disabled={true} />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="活动主题：" hasFeedback>
                {getFieldDecorator('subject', {
                  initialValue: (detail !== null && detail.subject) ? detail.subject : '',
                  rules: [
                    {
                      required: true,
                      message: '请输入主题'
                    },
                  ],
                })(<Input placeholder="请输入主题" type="text" />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12} id="classifyId">
              <FormItem label="分类：" hasFeedback>
                {getFieldDecorator('category', {
                  initialValue: (detail !== null && detail.category) ? detail.category : '',
                  rules: [
                    {
                      required: true,
                      message: '请选择分类'
                    },
                  ],
                })(
                  <Select
                    showSearch
                    allowClear
                    multiple={false}
                    disabled={detail.id ? true : false}
                    style={{ width: '100%' }}
                    placeholder="请选择分类"
                    optionFilterProp="desc"
                    getPopupContainer={() => document.getElementById('classifyId')}
                  >
                    {
                      promotionActivityType.map((item, key) => {
                        return <Select.Option key={key + ''} value={item.sKey + ''}
                                              desc={item.name}>{item.name}</Select.Option>
                      })
                    }
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12} id="activeId">
              <FormItem label="状态：" hasFeedback>
                {getFieldDecorator('active', {
                  initialValue: (detail !== null && detail.active) ? detail.active : '',
                  rules: [
                    {
                      required: true,
                      message: '请选择状态'
                    },
                  ],
                })(
                  <Select
                    showSearch
                    allowClear
                    multiple={false}
                    style={{ width: '100%' }}
                    placeholder="请选择状态"
                    optionFilterProp="desc"
                    getPopupContainer={() => document.getElementById('activeId')}
                  >
                    <Select.Option value='1' desc='有效'>有效</Select.Option>
                    <Select.Option value='0' desc='无效'>无效</Select.Option>
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="生效时间：" hasFeedback>
                {getFieldDecorator('startTime', {
                  initialValue: (detail !== null && detail.startTime) ? detail.startTime : null,
                  rules: [
                    {
                      required: true,
                      message: '请选择生效时间'
                    },
                  ],
                })(<DatePicker
                      showTime={true}
                      disabled={detail.id ? true : false}
                      onOpenChange={this.handleStartOpenChange.bind(this)}
                      disabledDate={this.disabledStartDate.bind(this)}
                      format="YYYY-MM-DD HH:mm:ss" style={{ width: '100%' }}/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="失效时间：" hasFeedback>
                {getFieldDecorator('endTime', {
                  initialValue: (detail !== null && detail.endTime) ? detail.endTime : null,
                  rules: [
                    {
                      required: true,
                      message: '请选择失效时间'
                    }
                  ]
                })(<DatePicker
                      showTime={true}
                      open={endOpen}
                      onOpenChange={this.handleEndOpenChange.bind(this)}
                      disabledDate={this.disabledEndDate.bind(this)}
                      format="YYYY-MM-DD HH:mm:ss" style={{ width: '100%' }}/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <FormItem label="适用范围：" hasFeedback>
                {getFieldDecorator('saleArea', {
                  initialValue: detail.saleArea || ''
                })(
                  <Input placeholder="请选择适用范围" onClick={this.selectRegionFn.bind(this)}/>
                )}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <FormItem label="活动描述：" hasFeedback>
                {getFieldDecorator('description', {
                  initialValue: (detail !== null && detail.description) ? detail.description : ''
                })(<Input.TextArea />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <DmsTab className="white-bg no-border" options={['适用产品']} defaultKey={0}>
        <Button icon="plus" onClick={this.addLine.bind(self)}>添加行</Button>
      </DmsTab>
      <div className="dms-table-box dms_xx">
        <Table {...productViewProps} bordered pagination={false}/>
      </div>
      <SelectRange ref={(node) => {this.selectRangModal = node;}}
                   keys={selectedKeys}
                   nodes={selectedNodes}
                   onOk={this.handleOk.bind(this)} />
      <ProductModal ref={(node) => {
        this.productModal = node;
      }} onOk={this.selectProductBack.bind(this)}/>
    </div>
  }
}
export default Form.create()(promotionAdd)


// WEBPACK FOOTER //
// ./src/routes/promotion/add.js